import HRLayout from './HRLayout';

export default HRLayout;
